export default __webpack_public_path__ + "static/media/g3GlTUN.5639a6cb.png";